import React from 'react';

export const SageGreeting = ({ greeting, animateIn }) => {
  return (
    <section 
      className={`mb-10 transition-all duration-700 ${animateIn ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
      style={{ transitionDelay: '0.1s' }}
    >
      <div 
        className="py-2"
        style={{ borderLeft: '2px solid #C9A84C', paddingLeft: '20px' }}
      >
        <h1 
          className="text-3xl md:text-4xl mb-2"
          style={{ 
            fontFamily: 'Playfair Display, serif',
            color: '#1A1A2E'
          }}
        >
          {greeting.primary}
        </h1>
        <p 
          className="text-base"
          style={{ 
            fontFamily: 'Jost, sans-serif',
            color: '#4A4A5A'
          }}
        >
          {greeting.secondary}
        </p>
      </div>
    </section>
  );
};
